"use client";

import { BookOpen, RotateCcw, ShoppingCart, Truck } from "lucide-react";
import { useTranslations } from "next-intl";
import { useShippingSettings } from "@/features/shipping/ui/hooks/useShippingSettings";
import { buildShippingVars, toTransitTemplateVars } from "@/features/shipping/shared/shippingVars";
import { Card, CardContent, Grid, Section, Text, VStack } from "@/ui";

export const PerksSection = () => {
  const perksT = useTranslations("perks");
  const { settings } = useShippingSettings();
  const shippingVars = toTransitTemplateVars(buildShippingVars(settings));

  const perks = [
    {
      title: perksT("perks.0.title"),
      icon: Truck,
      description: perksT("perks.0.description", shippingVars),
    },
    {
      title: perksT("perks.1.title"),
      icon: RotateCcw,
      description: perksT("perks.1.description", { returnDays: settings.returnWindowDays }),
    },
    {
      title: perksT("perks.2.title"),
      icon: ShoppingCart,
      description: perksT("perks.2.description"),
    },
    {
      title: perksT("perks.3.title"),
      icon: BookOpen,
      description: perksT("perks.3.description"),
    },
  ];

  return (
    <Section className="section-spacing bg-muted/20">
      <Card className="border-none bg-transparent shadow-none">
        <CardContent className="p-0">
          <VStack className="mx-auto mb-16 max-w-2xl items-center text-center">
            <span className="section-label mb-4">{perksT("label")}</span>
            <h2 className="heading-display">{perksT("title")}</h2>
            <p className="heading-sub mt-4">{perksT("subtitle")}</p>
          </VStack>

          <Grid className="mx-auto max-w-5xl grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {perks.map((perk) => (
              <div
                key={perk.title}
                className="group flex flex-col items-center text-center rounded-lg p-6 transition-all duration-300 hover:bg-background"
              >
                <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-full border border-border/50 bg-background transition-all duration-300 group-hover:border-primary/30 group-hover:shadow-md">
                  <perk.icon className="h-5 w-5 text-muted-foreground transition-colors duration-300 group-hover:text-primary" />
                </div>

                <VStack className="gap-2">
                  <Text className="font-medium text-foreground text-sm tracking-wide">
                    {perk.title}
                  </Text>
                  <Text className="text-sm leading-relaxed text-muted-foreground max-w-[200px]">
                    {perk.description}
                  </Text>
                </VStack>
              </div>
            ))}
          </Grid>
        </CardContent>
      </Card>
    </Section>
  );
};
